import { TraderClubActions } from './club-trader.actions';

export class ProfileTraderClub {
  public userId: number;
  public isTrader: boolean;
  public profileInfo: ProfileInfo;
  public dateFirstOperation?: Date;
  public dateLastOperation?: Date;
  public contractCurrentMonth: number;
  public contractLastMonth: number;
  public rankingPosition: number;
  public rankingMounth?: number;
  public platforms: Array<string>;
  public clubTrader: ClubTrader;
  public createdAt?: Date;
  public updatedAt?: Date;
  constructor() {
    this.userId = 0;
    this.isTrader = false;
    this.profileInfo = new ProfileInfo();
    this.dateFirstOperation = null;
    this.dateLastOperation = null;
    this.contractCurrentMonth = 0;
    this.contractLastMonth = 0;
    this.rankingPosition = 0;
    this.platforms = [];
    this.clubTrader = new ClubTrader();
    this.createdAt = null;
    this.updatedAt = null;
  }
}

export class ProfileInfo {
  typeProfile: string;
  dateEntry?: Date;
  dateDue?: Date;
}

export class ClubTrader {
  starter: {
    minimum: number;
    maximum: number;
  };
  master: {
    minimum: number;
    maximum: number;
  };
  vip: {
    minimum: number;
    maximum?: number;
  };
}

export class ProfileTraderState {
  public profileTraderClub: ProfileTraderClub;
}

export const initialState: ProfileTraderState = {
  profileTraderClub: new ProfileTraderClub(),
};

export function TraderClubReducer(
  state = initialState,
  action?: TraderClubActions
) {
  switch (action.type) {
    case TraderClubActions.getProfileTrader: {
      return {
        ...state,
        errors: null,
        pending: true,
      };
    }
    case TraderClubActions.getProfileTraderSuccess: {
      return {
        ...state,
        ...{ profile: action.payload, pending: false, errors: null },
      };
    }
    case TraderClubActions.getProfileTraderError:
      return { ...state, errors: action.payload, pending: false };
    default:
      return state;
  }
}
